import React, { useEffect } from 'react'
import { Stack } from '@mui/material'
import { useInstallationConfigurationTabs } from 'src/Libs/installations/hooks/installation-configuration/use-installation-configuration-tabs'
import BasicConfiguration from './BasicConfiguration'
import LocationConfiguration from './LocationConfiguration'
import OwnerConfiguration from './OwnerConfiguration'
import { useUserRoles } from 'src/Hooks/user'
import CompanySettings from './CompanySettings'
import { BlankView, BlankViewImageVariants } from 'src/Components/blank-view'
import { DeviceLinkModel, Installation } from 'src/Libs/installations'
import ComponentsList from 'src/Libs/installations/components/new-installation/configuration/general/ComponentsList'
import OfflineSyncPanel from 'src/Libs/installations/components/new-installation/configuration/general/OfflineSyncPanel'

interface Props {
  installationId?: number
  installation?: Installation
  installationLoading: boolean
  refreshInstallation: (installationId: string) => Promise<void>
  emcDeviceLink?: DeviceLinkModel
}

const GeneralSettings: React.FC<Props> = ({ installationId, installation, installationLoading, refreshInstallation, emcDeviceLink }) => {
  const { setActiveTab } = useInstallationConfigurationTabs(installationId)
  const { isServiceUser } = useUserRoles()

  useEffect(() => {
    setActiveTab(0)
  }, []) //eslint-disable-line react-hooks/exhaustive-deps

  if (!installationId) {
    return <BlankView imageVariant={BlankViewImageVariants.Neutral} title={'installation-configuration.missing-installation-id'} />
  }
  return (
    <Stack direction={'column'} gap={1}>
      <OfflineSyncPanel installationId={installationId} emcDeviceLink={emcDeviceLink} />
      <ComponentsList
        installationId={installationId}
        installation={installation}
        emcDeviceLink={emcDeviceLink}
        emcDeviceLinkId={installation?.emsMasterId?.toString()}
      />
      <BasicConfiguration installation={installation} installationId={installationId} installationLoading={installationLoading} />
      <LocationConfiguration installation={installation} installationId={installationId} installationLoading={installationLoading} />
      <OwnerConfiguration
        installationLoading={installationLoading}
        installationId={installationId}
        installation={installation}
        refreshInstallation={refreshInstallation}
      />
      {isServiceUser && <CompanySettings installationId={installationId} installationLoading={installationLoading} />}
    </Stack>
  )
}

export default GeneralSettings
